import { TowingEquipment } from "../hooks/useTowingEquipment";

/**
 * Resolves the default tug for a location (hangar or ramp), falling back to FBO default.
 *
 * Priority order:
 * 1. Location-specific tug (from location.towing_equipment_id)
 * 2. FBO default tug (from towing_equipment_in_use.is_default = true)
 * 3. undefined (if no default is configured)
 *
 * @param locationTowingEquipmentId - The towing_equipment_id from the hangar or ramp
 * @param availableTugs - List of available towing equipment (filtered to in_use tugs)
 * @returns The selected tug, or undefined if none found
 *
 * @example
 * // Hangar has specific tug configured
 * const tug = getDefaultTugForLocation(hangar.towing_equipment_id, towingEquipments);
 *
 * @example
 * // Ramp has no specific tug, falls back to FBO default
 * const tug = getDefaultTugForLocation(null, towingEquipments);
 */
export function getDefaultTugForLocation(
  locationTowingEquipmentId: string | null | undefined,
  availableTugs: TowingEquipment[]
): TowingEquipment | undefined {
  // Try location-specific tug first
  if (locationTowingEquipmentId) {
    const locationTug = availableTugs.find(
      (t) => t.towing_equipment_id === locationTowingEquipmentId
    );
    if (locationTug) {
      return locationTug;
    }
  }

  // Fall back to FBO default
  return availableTugs.find((t) => t.is_default);
}
